<template>
  <div class="v-process-spinner v-process-spinner__layout__indexed" v-if="isActive">
    <div class="v-process-spinner__spinner-container">
      <div class="v-process-spinner__spinner-container__centred">
        <div class="v-process-spinner__image-container">
          <img
            ref="loading_img"
            class="v-process-spinner__spinner-image"
            src="../assets/loading.png"
          >
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "VProcessSpinner",
  props: {
    isActive: {
      type: Boolean,
      default: false
    }
  },
  model: {
    prop: "isActive",
    event: "toggle"
  },
  methods: {
    toggle() {
      this.$emit("toggle", !this.isActive);

      return this.isActive;
    }
  }
};
</script>

<style>
.v-process-spinner {
  position: fixed;
  top: 0;
  left: 0;
  min-height: 100%;
  width: 100%;
  background: rgba(0, 0, 0, 0.6);
}

.v-process-spinner__layout__indexed {
  z-index: 101;
}

.v-process-spinner {
  display: table;
}

.v-process-spinner__spinner-container {
  display: table-cell;
  vertical-align: middle;
}

.v-process-spinner__spinner-container__centred {
  display: flex;
  justify-content: center;
}

.v-process-spinner__image-container {
  width: 120px;
  height: 120px;
}

@keyframes rotating {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}

.v-process-spinner__spinner-image {
  width: 100%;
  height: 100%;
  animation: rotating 800ms linear infinite;
}
</style>
